import { forwardRef } from 'react';

import { IconProps } from '../';

export const TimelineCircleIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <g filter="url(#filter0_d_4003_40695)">
        <circle cx="5" cy="5" r="5" transform="matrix(0 -1 -1 0 15 14.5)" fill="#F6BB2D" />
        <circle cx="5" cy="5" r="6" transform="matrix(0 -1 -1 0 15 14.5)" fill="none" stroke="white" strokeWidth="2" />
      </g>
      <defs>
        <filter id="filter0_d_4003_40695" x="1" y="1.5" width="18" height="18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4003_40695" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4003_40695" result="shape" />
        </filter>
      </defs>
    </svg>
  );
});

export default TimelineCircleIcon;
